/* MATCHA SOURCE V2 — Editorial interactions */
(function(){
  'use strict';

  // ----- sticky header -----
  var header = document.querySelector('.site-header');
  if (header){
    var stuck = false;
    var onScroll = function(){
      var s = window.scrollY > 24;
      if (s !== stuck){
        stuck = s;
        header.classList.toggle('is-stuck', s);
      }
    };
    window.addEventListener('scroll', onScroll, {passive:true});
    onScroll();
  }

  // ----- mobile nav toggle -----
  var toggle = document.querySelector('.nav-toggle');
  var nav = document.querySelector('.site-nav');
  if (toggle && nav){
    if (toggle.__navBound) return; toggle.__navBound = true;
    function closeNav(){
      toggle.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      nav.removeAttribute('style');
      document.body.style.overflow = '';
    }
    toggle.addEventListener('click', function(e){
      var open = toggle.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
      nav.style.display = open ? 'flex' : '';
      if (open){
        nav.style.flexDirection = 'column';
        nav.style.position = 'absolute';
        nav.style.top = '100%';
        nav.style.left = '0';
        nav.style.right = '0';
        nav.style.background = 'rgba(14,92,68,.96)';
        nav.style.backdropFilter = 'blur(14px)';
        nav.style.padding = '24px 32px 32px';
        nav.style.gap = '20px';
        nav.style.borderTop = '1px solid rgba(212,179,106,.2)';
      } else {
        closeNav();
      }
    });
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape' && toggle.classList.contains('is-open')) closeNav();
    });
  }

  // ----- FAQ accordion -----
  document.querySelectorAll('[data-faq-item]').forEach(function(item){
    var trigger = item.querySelector('[data-faq-trigger]');
    if (!trigger) return;
    var panel = item.querySelector('.faq-item__panel');
    trigger.addEventListener('click', function(){
      var list = item.closest('[data-faq-list]');
      var allowMulti = list && list.dataset.faqMulti === 'true';
      if (!allowMulti){
        list.querySelectorAll('[data-faq-item].is-open').forEach(function(o){
          if (o !== item){ o.classList.remove('is-open'); var op = o.querySelector('.faq-item__panel'); if (op) op.style.maxHeight = '0px'; }
        });
      }
      var willOpen = !item.classList.contains('is-open');
      item.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', String(willOpen));
      /* 面板高度按内容实测——答案长短不一（含列表），写死 max-height 会裁掉长答案 */
      if (panel) panel.style.maxHeight = willOpen ? (panel.scrollHeight + 'px') : '0px';
    });
  });
  /* 窗口尺寸变化时重算展开中的面板高度（换行变化会导致裁切） */
  var faqResizeTimer = null;
  window.addEventListener('resize', function(){
    clearTimeout(faqResizeTimer);
    faqResizeTimer = setTimeout(function(){
      document.querySelectorAll('[data-faq-item].is-open .faq-item__panel').forEach(function(p){
        p.style.maxHeight = p.scrollHeight + 'px';
      });
    }, 150);
  });

  // ----- IntersectionObserver reveals -----
  // 三重保险：① 主题编辑器里直接全显（编辑器 iframe 里 IO 常常不触发）
  //           ② 不支持 IO 就全显  ③ 2.5s 兜底全显，绝不允许内容永久隐形
  var revealEls = document.querySelectorAll('.reveal');
  var inDesignMode = !!(window.Shopify && window.Shopify.designMode);
  if (!inDesignMode && 'IntersectionObserver' in window && document.body.classList.contains('ms-anim')){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, {threshold:.12, rootMargin:'0px 0px -8% 0px'});
    revealEls.forEach(function(el){io.observe(el)});
    setTimeout(function(){
      revealEls.forEach(function(el){ el.classList.add('is-in') });
    }, 2500);
  } else {
    revealEls.forEach(function(el){el.classList.add('is-in')});
  }

  // ----- product variant selected highlight -----
  document.querySelectorAll('[data-variant-picker]').forEach(function(group){
    group.querySelectorAll('[data-variant-option]').forEach(function(opt){
      opt.addEventListener('click', function(){
        group.querySelectorAll('[data-variant-option]').forEach(function(o){o.classList.remove('is-active')});
        opt.classList.add('is-active');
      });
    });
  });

  /* ---------- INSIGHTS：分类筛选 + 搜索 + Load More ---------- */
  (function(){
    var nav = document.querySelector('[data-journal-nav]');
    if (!nav) return;
    var grids = document.querySelectorAll('[data-journal-grid]');

    /* 没有任何可筛的卡片时（博客未读到 / 一篇未发），整条分类器收起来 */
    function hideNav(){
      var navWrap = nav.closest('.jnav-wrap');
      if (navWrap) navWrap.hidden = true;
      var tip = document.querySelector('[data-journal-empty]');
      if (tip) tip.hidden = true;
    }
    /* 注意：网格区块在「零篇」时整块不渲染，此时 grids 为空，
       必须在提前返回之前先把分类条收掉，否则页面只剩一排点不出内容的按钮 */
    if (!grids.length){ hideNav(); return; }

    var activeFilter = 'all';
    var query = '';
    var emptyTip = document.querySelector('[data-journal-empty]');

    var totalCards = 0;
    grids.forEach(function(g){ totalCards += g.querySelectorAll('.jcard').length; });
    if (!totalCards){ hideNav(); return; }

    function cardMatches(card){
      var cat = (card.getAttribute('data-cat') || '').toLowerCase();
      var okCat = activeFilter === 'all' || cat === activeFilter;
      var okText = !query || (card.textContent || '').toLowerCase().indexOf(query) !== -1;
      return okCat && okText;
    }

    function apply(){
      var anyVisible = false;
      grids.forEach(function(grid){
        var visible = parseInt(grid.getAttribute('data-visible'), 10) || 6;
        var hasMore = !!grid.querySelector('[data-journal-more]');
        var shown = 0;
        var cards = grid.querySelectorAll('.jcard');
        cards.forEach(function(card){
          var match = cardMatches(card);
          var limit = hasMore ? visible : Infinity;
          var show = match && shown < limit;
          card.classList.toggle('jcard--hidden', !show);
          card.classList.toggle('jcard--filtered', !match);
          if (show) shown++;
          if (match) anyVisible = true;
        });
        var moreWrap = grid.querySelector('[data-journal-more-wrap]');
        if (moreWrap){
          var hiddenMatched = 0;
          cards.forEach(function(card){
            if (cardMatches(card) && card.classList.contains('jcard--hidden')) hiddenMatched++;
          });
          moreWrap.style.display = hiddenMatched > 0 ? '' : 'none';
        }
      });
      if (emptyTip) emptyTip.hidden = anyVisible;
    }

    nav.addEventListener('click', function(e){
      var btn = e.target.closest('[data-filter]');
      if (!btn) return;
      nav.querySelectorAll('[data-filter]').forEach(function(b){ b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      activeFilter = (btn.getAttribute('data-filter') || 'all').toLowerCase();
      apply();
    });

    var search = document.querySelector('[data-journal-search]');
    if (search){
      search.addEventListener('input', function(){
        query = (search.value || '').trim().toLowerCase();
        apply();
      });
    }

    document.querySelectorAll('[data-journal-more]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var grid = btn.closest('[data-journal-grid]');
        if (grid){ grid.setAttribute('data-visible', '999'); apply(); }
      });
    });

    // 初始化就跑一次：把超出首屏数量的卡片收起来，没有可展开的就隐藏按钮
    apply();
  })();

  /* ---------- 文章详情：复制链接 ---------- */
  (function(){
    var btns = document.querySelectorAll('[data-art-copy]');
    if (!btns.length) return;
    btns.forEach(function(btn){
      var label = btn.textContent;
      btn.addEventListener('click', function(){
        var url = btn.getAttribute('data-art-copy');
        function done(ok){
          btn.textContent = ok ? 'Copied ✓' : 'Copy failed';
          setTimeout(function(){ btn.textContent = label; }, 1800);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(function(){ done(true); }, function(){ done(false); });
        } else {
          var t = document.createElement('textarea');
          t.value = url; t.setAttribute('readonly', '');
          t.style.position = 'absolute'; t.style.left = '-9999px';
          document.body.appendChild(t); t.select();
          var ok = false;
          try { ok = document.execCommand('copy'); } catch(e){ ok = false; }
          document.body.removeChild(t);
          done(ok);
        }
      });
    });
  })();

  /* ---------- SHOP：筛选 / 规格 / 数量 / 加购 / 浮动购物车 ---------- */
  (function(){
    var grid = document.querySelector('[data-shop-grid]');
    if (!grid) return;

    // 类目筛选（同页客户端过滤）
    var filters = grid.querySelectorAll('[data-family]');
    if (filters.length){
      filters.forEach(function(btn){
        btn.addEventListener('click', function(){
          filters.forEach(function(b){ b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          var fam = btn.dataset.family;
          grid.querySelectorAll('.scard').forEach(function(card){
            card.style.display = (fam === 'all' || card.dataset.family === fam) ? '' : 'none';
          });
        });
      });
    }

    // 规格切换 + 数量
    grid.querySelectorAll('.scard').forEach(function(card){
      var price = card.querySelector('[data-pack-price]');
      card.querySelectorAll('.scard__chip').forEach(function(chip){
        chip.addEventListener('click', function(){
          card.querySelectorAll('.scard__chip').forEach(function(c){
            c.classList.remove('is-active'); c.setAttribute('aria-pressed','false');
          });
          chip.classList.add('is-active'); chip.setAttribute('aria-pressed','true');
          if (price) price.innerHTML = (chip.dataset.price || '$0.00') + ' <small>USD</small>';
        });
      });
      var input = card.querySelector('[data-qty-input]');
      card.querySelectorAll('[data-qty]').forEach(function(btn){
        btn.addEventListener('click', function(){
          var v = parseInt(input.value, 10) || 1;
          v = Math.min(999, Math.max(1, v + parseInt(btn.dataset.qty, 10)));
          input.value = v;
        });
      });
      if (input){
        input.addEventListener('change', function(){
          input.value = Math.min(999, Math.max(1, parseInt(input.value, 10) || 1));
        });
      }
    });

    // 产品卡图库：左右小三角 / 圆点 / 触屏滑动 /（可选）自动轮播
    var galAuto = grid.dataset.galAutoplay === 'true';
    var galInterval = (parseInt(grid.dataset.galInterval, 10) || 6) * 1000;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    grid.querySelectorAll('[data-gallery]').forEach(function(gal){
      var track = gal.querySelector('[data-track]');
      var slides = gal.querySelectorAll('.scard__slide');
      var dots = gal.querySelectorAll('[data-gal-dot]');
      if (!track || slides.length < 2) return;

      var idx = 0, timer = null, hovering = false;

      function go(n){
        idx = (n + slides.length) % slides.length;
        track.style.transform = 'translateX(' + (-idx * 100) + '%)';
        dots.forEach(function(d, k){
          d.classList.toggle('is-active', k === idx);
          if (k === idx) d.setAttribute('aria-current', 'true');
          else d.removeAttribute('aria-current');
        });
      }
      function stop(){ if (timer){ clearInterval(timer); timer = null; } }
      function start(){
        stop();
        if (!galAuto || reduceMotion || hovering) return;
        timer = setInterval(function(){ go(idx + 1); }, galInterval);
      }

      var prevBtn = gal.querySelector('[data-gal-prev]');
      var nextBtn = gal.querySelector('[data-gal-next]');
      if (prevBtn) prevBtn.addEventListener('click', function(){ go(idx - 1); start(); });
      if (nextBtn) nextBtn.addEventListener('click', function(){ go(idx + 1); start(); });
      dots.forEach(function(d){
        d.addEventListener('click', function(){ go(parseInt(d.dataset.galDot, 10) || 0); start(); });
      });

      // 触屏：横向滑过 35px 才算翻页，纵向滑动不拦截
      var sx = 0, sy = 0, dragged = false;
      gal.addEventListener('touchstart', function(e){
        sx = e.touches[0].clientX; sy = e.touches[0].clientY; dragged = false;
      }, { passive: true });
      gal.addEventListener('touchmove', function(e){
        var dx = e.touches[0].clientX - sx, dy = e.touches[0].clientY - sy;
        if (Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) dragged = true;
      }, { passive: true });
      gal.addEventListener('touchend', function(e){
        if (!dragged) return;
        var dx = e.changedTouches[0].clientX - sx;
        if (dx < -35) go(idx + 1);
        else if (dx > 35) go(idx - 1);
        start();
      });

      gal.addEventListener('mouseenter', function(){ hovering = true; stop(); });
      gal.addEventListener('mouseleave', function(){ hovering = false; start(); });
      gal.addEventListener('focusin', stop);
      gal.addEventListener('focusout', start);

      // 自动轮播只在卡片进入视口时跑，滚过去就停，省电也省心
      if (galAuto && !reduceMotion && 'IntersectionObserver' in window){
        new IntersectionObserver(function(entries){
          entries.forEach(function(en){ if (en.isIntersecting) start(); else stop(); });
        }, { threshold: 0.35 }).observe(gal);
      } else {
        start();
      }
      go(0);
    });

    // 加购（角标由全站浮动购物袋模块接管，加完调 window.MSCart.refresh）
    grid.querySelectorAll('[data-add-to-cart]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var card = btn.closest('.scard');
        var notice = card.querySelector('[data-cart-notice]');
        var show = function(msg){ if(notice){ notice.hidden = false; notice.textContent = msg; } };
        var chip = card.querySelector('.scard__chip.is-active');
        var qty = parseInt((card.querySelector('[data-qty-input]')||{value:1}).value, 10) || 1;
        var handle = btn.dataset.productHandle;

        if (!handle){
          show('Online ordering for this grade is being prepared — use Request a Bulk Quote meanwhile.');
          return;
        }
        btn.disabled = true;
        fetch('/products/' + handle + '.js').then(function(r){
          if (!r.ok) throw { code: 'noproduct' };
          return r.json();
        }).then(function(prod){
          var size = chip ? (chip.dataset.size || '').toUpperCase() : '';
          var v = (prod.variants || []).find(function(vv){
            return (vv.options || []).some(function(o){ return String(o).toUpperCase() === size; });
          });
          if (!v) throw { code: 'novariant' };
          if (v.available === false) throw { code: 'unavailable' };
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: v.id, quantity: qty }] })
          }).then(function(r){
            if (!r.ok) throw { code: 'cart' };
            return r.json();
          });
        }).then(function(){
          show('Added to cart ✓');
          var qi = card.querySelector('[data-qty-input]');
          if (qi) qi.value = 1;
          if (window.MSCart) window.MSCart.refresh();
        }).catch(function(err){
          var code = err && err.code;
          show(code === 'noproduct'  ? 'Online ordering for this grade is being prepared — use Request a Bulk Quote meanwhile.'
             : code === 'unavailable' ? 'This pack size is currently unavailable.'
             : code === 'novariant'   ? 'Selected pack size was not found for this product.'
             : 'Unable to add to cart — please adjust your selection and try again.');
        }).finally(function(){ btn.disabled = false; });
      });
    });
  })();

})();
